import Seo from "../Seo/Seo";
import BgSlider from "../Hero/bg";
import About from "../About/about";

export default function Accueil() {
    return <>
        <Seo
            title="Provence Paie | Expertise paie et RH pour cabinets d'expertise comptable"
            description="Une gestion sociale dédiée aux cabinets d'expertise comptable en Provence : externalisation paie, conformité et accompagnement RH haut de gamme."
            pathname="/"
        />
        <BgSlider
            title="PROVENCE PAIE"
            subtitle="Expertise, transparence et optimisation au service de votre réussite."
        />
        <About />
    </>
}